
//0～9:レスポンス系
//10～19:固定幅検知
//20～:固定幅入力

//[duplicated] 同じ定義がMelon（Back）にもあるので値を変える場合は一緒に変更すること
export const PublicPageLayoutSize = {
	RESPONSIVE: 0,
	FIXED_DETECT: 10,
	FIXED_SIZE: 20,
} as const;

type PublicPageLayoutSize = typeof PublicPageLayoutSize
export type PublicPageLayoutSizeEnum = PublicPageLayoutSize[keyof PublicPageLayoutSize]




